import React from "react";
import { styled } from "styled-components";

/** Renders nothing unless this build was made with `REACT_APP_ENV=staging` baked in at build
 *  time — set only by `scripts/env.staging.sh` (staging deploys of `frontend`/`customer-frontend`)
 *  and each app's `.env.defaults` (local dev, which always points at staging resources anyway).
 *  Prod's `scripts/env.prod.sh` never sets it, so a prod build has it unset and this returns null —
 *  no separate "prod" branch to keep in sync, just the absence of the flag. */
const StyledStagingBadge = styled.span`
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  margin-left: 10px;
  border-radius: 4px;
  background-color: var(--orange400, #ffa726);
  color: #1a1305;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  flex-shrink: 0;
`;

const StagingBadge = () => {
  if (process.env.REACT_APP_ENV !== "staging") {
    return null;
  }
  return <StyledStagingBadge>STAGING</StyledStagingBadge>;
};

export default StagingBadge;
